import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { HeroImage } from '.';
import { heroImageDriverFactory } from './HeroImage.driver';

describe('HeroImage', () => {
  const createDriver = createRendererWithUniDriver(heroImageDriverFactory);

  const sampleSource = 'c5f754_186e90ba2c9b47de8a4a0a0346865b72~mv2.png';
  const sampleDimensions = { width: 800, height: 300 };

  it('should render', async () => {
    const { driver } = createDriver(
      <HeroImage src={sampleSource} {...sampleDimensions} />,
    );

    expect(await driver.exists()).toBe(true);
  });
});
